import '../../css/flag-icons.min.css';
import clsx from 'clsx';

type Props = {
  isoCode: string;
  size: 'small' | 'large';
  isActive?: boolean;
};

export default function Flag({isoCode, size, isActive}: Props) {
  return (
    <span
      className={clsx(
        `fi fi-${isoCode.toLowerCase()} block rounded-full !bg-cover`,
        size === 'small' && '!h-7 !w-7 md:!h-8 md:!w-8',
        size === 'large' && '!h-[48px] !w-[48px]',
        isActive && 'border-2 border-orange',
      )}
    />
  );
}
